export default {
  "pcItemCbLabel": "Buy with cashback!",
  "pcItemBtn": "Check prices",
  "pcItemPriceText": "from",
}